// Ce fichier contient le code qui enregistre le service worker
// permettant à l'application de fonctionner hors ligne.

// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Détecter si nous sommes dans un environnement mobile (Capacitor)
const isMobileApp = () => {
  return window.location.protocol.includes('capacitor') || 
         document.URL.includes('capacitor://') ||
         document.URL.includes('localhost/');
};

export function register(config) {
  // Ne jamais enregistrer le service worker dans une application mobile
  if (isMobileApp()) {
    return;
  }
  
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // L'URL constructor est disponible dans tous les navigateurs qui supportent SW
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Notre service worker ne fonctionnera pas si PUBLIC_URL est sur une origine différente
      // de celle de notre page. Cela peut arriver si un CDN est utilisé pour servir les assets.
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Ceci s'exécute sur localhost. Vérifions si un service worker existe toujours.
        checkValidServiceWorker(swUrl, config);

        // Ajout de logs supplémentaires pour localhost
        navigator.serviceWorker.ready.then(() => {
          // Suppression du log pour localhost
        });
      } else {
        // Pas localhost. Enregistrement du service worker
        registerValidSW(swUrl, config);
      }
    });

    // Ajout d'un event listener pour la mise à jour du service worker
    window.addEventListener('appinstalled', (evt) => {
      // Suppression du log d'installation
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Exécute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Exécute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      // Suppression du log d'erreur
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Vérifie si le service worker peut être trouvé. S'il ne peut pas être rechargé la page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // S'assure que le service worker existe et que nous obtenons réellement un fichier JS.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Aucun service worker trouvé. Probablement une autre app. Rechargez la page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker trouvé. Procéder normalement.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      // Suppression du log
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        // Suppression du log d'erreur
      });
  }
}